import cn from 'classnames';

import classes from './completion.module.scss';

export const Completion = ({ complectionText,messageType }: any) => {
  return (
    <div className={classes.root} id="registration-completion-form">
      <div className={classes.iconWrapper}>
        {messageType === 'Success' && <i className={cn('pi pi-check-circle', classes.icon)} />}
        {messageType === 'Error' && <i className={cn('pi pi-times-circle', classes.errorIcon)} />}
      </div>
      <div className={classes.message}>{complectionText}</div>
    </div>
  );
};